// extracted by mini-css-extract-plugin
export default {"xlarge":"Button_xlarge__Ykk8y","xxlarge":"Button_xxlarge__XTriL"};